import React, { useState } from "react";
import styles from "./Footer.module.scss";
import { PUBLIC_IMAGE } from "../../constants";
import { observer } from "mobx-react-lite";
import { useLocation, useNavigate } from "react-router-dom";
import { EXCHANGER_ROUTE, POOLS_ROUTE } from "../../utils/consts";
import { useForm, ValidationError } from "@formspree/react";
import MyInput from "../UI/MyInput/MyInput";

const Footer = observer(() => {
  const mainLogoPath = PUBLIC_IMAGE + "main-logo.svg";
  const navigate = useNavigate();
  const [state, handleSubmit] = useForm("xnnvykgl");
  const [isSending, setIsSending] = useState<boolean>(false);
  const [emailValue, setEmailValue] = useState<string>("");
  const [isValidateEmail, setIsValidateEmail] = useState<boolean | undefined>(true);
  const location = useLocation();

  const handleLinkClick = (route: string) => {
    navigate(route);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      setIsValidateEmail(false);
      return false;
    } else if (!emailRegex.test(email)) {
      setIsValidateEmail(false);
      return false;
    } else {
      setIsValidateEmail(true);
      return true;
    }
  };

  const sendMessage = async () => {
    await validateEmail(emailValue);
    if (isSending || !validateEmail(emailValue)) return;

    await setIsSending(true);
    try {
      const response = await fetch("/api/v1/services/feedback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            page: location.pathname.replace("/", ""),
            email: emailValue,
          },
        }),
      });

      const data = await response.json();
    } catch (e) {
      console.error("Ошибка:", e);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.header__innerFooterMain}>
            <nav className={styles.menu}>
              <ul className={styles.menu__listHeader}>
                <li className={styles.menu__listItem}>
                  <a
                    className={styles.menu__listLink}
                    onClick={() => navigate(EXCHANGER_ROUTE)}
                  >
                    AI Smart Rate
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/cards/"
                    className={styles.menu__listLink}
                  >
                    Cards
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/credits"
                    className={styles.menu__listLink}
                  >
                    Bots
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="#"
                    className={styles.menu__listLink}
                    onClick={() => {
                      navigate(POOLS_ROUTE);
                      handleLinkClick(POOLS_ROUTE);
                    }}
                  >
                    Pools
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/coming_soon"
                    className={styles.menu__listLink}
                  >
                    Credits
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/payments/business/"
                    className={styles.menu__listLink}
                  >
                    Payments
                  </a>
                  <div
                      className={`${styles.menu__dropdownContent} ${styles.dropdown__sheepyBurger} ${styles.dropdown__sheepyFooter}`}
                    >
                      <div className={styles.menu__dropdownWrapper}>
                        <img src="./image/dropdown-iconImage.svg" alt="" />
                        <a href="https://alfa-crypto.com/payments/business/">
                          <div className={styles.menu__dropdownTitle}>
                            Business
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Accept major cryptocurrencies, manage fiat <br></br>{" "}
                            converson, keep or request payouts.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img src="./image/dropdown-iconImage.svg" alt="" />
                        <a href="https://alfa-crypto.com/fundraising">
                          <div className={styles.menu__dropdownTitle}>
                            Fundraising
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Accept major cryptocurrencies, manage fiat <br></br>{" "}
                            converson, keep or request payouts.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img src="./image/dropdown-iconImage.svg" alt="" />
                        <a href="https://alfa-crypto.com/merchant">
                          <div className={styles.menu__dropdownTitle}>
                            Merchant
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Send payments to multiple recipients <br></br>{" "}
                            simultaneously.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img src="./image/dropdown-iconImage.svg" alt="" />
                        <a href="https://alfa-crypto.com/demo">
                          <div className={styles.menu__dropdownTitle}>Demo</div>
                          <div className={styles.menu__dropdownText}>
                            Send payments to multiple recipients <br></br>{" "}
                            simultaneously.
                          </div>
                        </a>
                      </div>
                  </div>
                  <img
                    src={PUBLIC_IMAGE + "Header-arrowImageDown.svg"}
                    alt=""
                    className={styles.menu__itemArrow}
                  />
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/company"
                    className={styles.menu__listLink}
                  >
                    Company
                  </a>
                  <div
                      className={`${styles.menu__dropdownContent} ${styles.dropdown__companyBurger} ${styles.dropdown__companyFooter}`}
                    >
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a href="https://alfa-crypto.com/company">
                          <div className={styles.menu__dropdownTitle}>
                            About us
                          </div>
                          <div className={styles.menu__dropdownText}></div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a href="https://alfa-crypto.com/white_paper" target="_blank" rel="noreferrer">
                          <div className={styles.menu__dropdownTitle}>
                            White paper
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Accept major cryptocurrencies, manage fiat <br></br>{" "}
                            converson, keep or request payouts.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a href="https://alfa-crypto.com/company#faq-content">
                          <div className={styles.menu__dropdownTitle}>FAQ</div>
                          <div className={styles.menu__dropdownText}>
                            Send payments to multiple recipients <br></br>{" "}
                            simultaneously.
                          </div>
                        </a>
                      </div>
                  </div>
                  <img
                    src={PUBLIC_IMAGE + "Header-arrowImageDown.svg"}
                    alt=""
                    className={styles.menu__itemArrow}
                  />
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/account"
                    className={styles.menu__listLink}
                  >
                    Account
                  </a>
                </li>
                <div className={styles.menu__listItemLine}></div>
                <li className={styles.menu__listItem}>
                  <a href="#" className={styles.menu__listLink}>
                    En
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className={styles.header__innerFooterPhone}>
            <ul className={styles.menu_listFooter}>
              <li className={styles.menu__listItem}>
                <a
                  href="https://alfa-crypto.com"
                  className={`${styles.menu__listLink} ${styles.footer_listItem}`}
                >
                  Products
                </a>
              </li>
              <li className={styles.menu__listItem}>
                <a
                  href="https://alfa-crypto.com/company"
                  className={`${styles.menu__listLink} ${styles.footer_listItem}`}
                >
                  Company
                </a>
              </li>
              <li
                className={styles.menu__listItem}
                onClick={() =>
                  window.open("https://alfa-crypto.com/white_paper", "_blank")
                }
              >
                <a
                  className={`${styles.menu__listLink} ${styles.footer_listItem}`}
                >
                  White papper
                </a>
              </li>
              <li
                onClick={() =>
                  window.open(
                    "https://alfa-crypto.com/company#faq-content",
                    "_blank"
                  )
                }
                className={styles.menu__listItem}
              >
                <a
                  className={`${styles.menu__listLink} ${styles.footer_listItem}`}
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.footer__inner}>
        <div className={styles.footer__contact}>
          <div className={styles.container}>
            <div className={styles.footer__contactWrapper}>
              <div className={styles.footer__contactInput}>
                <p className={styles.footer__contactText}>Contact Us</p>
                <div>
                  {!isValidateEmail && (
                    <p className={styles.footer__errorText}>
                      Please enter a valid email.
                    </p>
                  )}
                </div>
                <div className={styles.footer__inputBox}>
                  <MyInput
                    id="name"
                    type="name"
                    name="name"
                    className={styles.footer__inputForm}
                    placeHolder="Enter your name"
                    onChange={(e) => setEmailValue(e.target.value)}
                  />
                  <button
                    className={styles.footer__contactButton}
                    onClick={() => sendMessage()}
                  >
                    {isSending ? "Sending..." : "Send"}
                  </button>
                </div>
              </div>
              <div className={styles.footer__contactItem}>
                <a
                  href="https://x.com/alfaaacrypto"
                  className={styles.footer__contactLink}
                >
                  <img src={PUBLIC_IMAGE + "X.svg"} alt="" />
                </a>
                <a
                  href="https://t.me/alfacryptoproject"
                  className={styles.footer__contactLink}
                >
                  <img src={PUBLIC_IMAGE + "Tg.svg"} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.copy__nav}>
          <ul className={styles.copy__navList}>
            <li className={styles.copy__navItem}>
              <a href="#" className={styles.copy__navLink}>
                © Copyright{" "}
              </a>
            </li>
            <span className={styles.copy__navPoint}></span>
            <li>
              <a href="#" className={styles.copy__navLink}>
                Privacy policy
              </a>
            </li>
            <span className={styles.copy__navPoint}></span>
            <li className={styles.copy__navItem}>
              <a href="#" className={styles.copy__navLink}>
                Terms of service
              </a>
            </li>
          </ul>
        </div>
        <div
          className={`${styles.light__box} ${styles.light__boxFooter}`}
        ></div>
      </div>
    </footer>
  );
});

export default Footer;
